import { render, staticRenderFns } from "./DegreesPage.vue?vue&type=template&id=13615c9e"
import script from "./DegreesPage.vue?vue&type=script&lang=js"
export * from "./DegreesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports